import type { Theme } from '@mui/material';

const ERROR_REASONS = ['registered_call_timeout', 'concurrency_limit_reached'];
const POLICY_REASONS = ['inbound_country_blocked', 'payment_overdue'];

// Colors for Interaction#disconnection_reason codes (backend utils/disconnection_reasons.yml).
const END_REASON_COLORS: Record<string, { main: string; bg: string }> = {
  user_hangup: { main: '#7C00B1', bg: '#F5DFFF' },
  agent_hangup: { main: '#195EFF', bg: '#D2ECFF' },
  cold_transferred: { main: '#0F7070', bg: '#DFFFFF' },
  warm_transferred: { main: '#3E6901', bg: '#EEFFD4' },
  agent_transfer: { main: '#1E40AF', bg: '#EEF5FF' },
  call_take_over: { main: '#077F13', bg: '#DBFCDE' },
  voicemail_reached: { main: '#4338CA', bg: '#ECEEFF' },
  inactivity: { main: '#777777', bg: '#ECECEC' },
  max_duration_reached: { main: '#475569', bg: '#EEF1F5' },
  concurrency_fallback_success: { main: '#047857', bg: '#D9F7EA' }
};

export function getEndReasonBadgeColor(reason: string, theme: Theme) {
  const mapped = END_REASON_COLORS[reason];
  if (mapped) {
    return mapped;
  }
  if (reason.startsWith('error_') || ERROR_REASONS.includes(reason)) {
    return { bg: theme.palette.error.light, main: theme.palette.error.main };
  }
  if (POLICY_REASONS.includes(reason)) {
    return { bg: '#ECECEC', main: '#777777' };
  }
  return { bg: '#F5DFFF', main: '#7C00B1' };
}
